import React from "react";
import * as S from "./Styles";

export type ButtonVariant = "primary" | "secondary" | "tertiary";

export interface ButtonProps {
  text: string;
  onClick?: () => void;
  variant?: ButtonVariant;
  href?: string;
  target?: string;
  rel?: string;
  isLoading?: boolean;
  type?: "button" | "submit" | "reset";
}

export const Button: React.FC<ButtonProps> = ({
  text,
  onClick,
  variant = "primary",
  isLoading = false,
  type = "button",
}) => {
  return (
    <S.StyledButton
      onClick={onClick}
      $variant={variant}
      disabled={isLoading}
      type={type}
    >
      {isLoading ? (
        <S.SpinnerWrapper>
          <S.Spinner />
          <S.SpinnerText>Laster...</S.SpinnerText>
        </S.SpinnerWrapper>
      ) : (
        text
      )}
    </S.StyledButton>
  );
};
